// i18n area 'auth' — locale nl-NL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.nl-NL.meta.json.
import type { enUS } from './auth'

export const nlNL: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Log in op je account',
    username: 'Gebruikersnaam',
    usernamePlaceholder: 'Voer je gebruikersnaam in',
    usernameHint: 'Gebruik gebruiker@domein om in te loggen op een directory-realm',
    continue: 'Doorgaan',
    changeUser: 'Ben jij dit niet?',
    password: 'Wachtwoord',
    forgotPassword: 'Wachtwoord vergeten?',
    submit: 'Inloggen',
    otp: 'Eenmalige code',
    otpSubtitle: 'Voer de code uit je authenticator in',
    otpHint: 'Zes cijfers uit je authenticator-app, of een van je herstelcodes',
    otpSubmit: 'Verifiëren',
    invalidCredentials: 'Ongeldige gebruikersnaam of ongeldig wachtwoord',
    tooManyAttempts: 'Te veel pogingen — wacht even en probeer het opnieuw',
    realmUnavailable: 'Het realm kan de credentials op dit moment niet verifiëren — de store van het cluster is niet bereikbaar. Log in als lokale gebruiker (break-glass).',
    genericError: 'Inloggen mislukt — is de TVirt-backend bereikbaar?'
  },
  user: {
    logout: 'Uitloggen',
    password: {
      menu: 'Wachtwoord wijzigen',
      title: 'Wijzig je wachtwoord',
      current: 'Huidig wachtwoord',
      new: 'Nieuw wachtwoord',
      confirm: 'Bevestig het nieuwe wachtwoord',
      mismatch: 'De wachtwoorden komen niet overeen',
      error: 'Het wachtwoord kon niet worden gewijzigd',
      forcedTitle: 'Wijzig je wachtwoord om verder te gaan',
      forcedHint: 'Dit wachtwoord is door een beheerder ingesteld en moet vervangen worden voordat je naar binnen kunt.',
      forcedSubmit: 'Wijzigen en doorgaan'
    },
    mfa: {
      title: 'Tweefactorauthenticatie',
      subtitle: 'Een tweede factor die bij elke login wordt gevraagd',
      loadError: 'De status van de tweede factor kon niet worden geladen',
      enrolled: 'Actief',
      notEnrolled: 'Niet actief',
      enrolledAt: 'Geactiveerd op',
      codesRemaining: 'Resterende herstelcodes',
      requiredHint:
        'Een beheerder vereist de tweede factor op dit account: stel hem nu in — zolang je dat niet doet kun je wel inloggen, maar weinig meer dan dat.',
      enroll: 'Instellen',
      enrollTitle: 'Tweefactorauthenticatie instellen',
      enrollHint: 'Scan deze code met je authenticator-app en typ daarna de code die de app toont om te bevestigen.',
      secretHint: 'Lukt scannen niet? Typ dit geheim dan in de app:',
      code: 'Code uit de app',
      confirm: 'Bevestigen',
      startError: 'De configuratie kon niet worden gestart',
      confirmError: 'De configuratie kon niet worden bevestigd',
      codesTitle: 'Je herstelcodes',
      codesWarning:
        'Deze codes worden maar één keer getoond. Sla ze nu op: elke code laat je inloggen wanneer je authenticator niet beschikbaar is, en werkt precies één keer.',
      codesAck: 'Ik heb mijn herstelcodes opgeslagen',
      codesDone: 'Klaar',
      copy: 'Kopiëren',
      copied: 'Gekopieerd',
      download: 'Downloaden',
      regenerate: 'Nieuwe herstelcodes',
      regenerateTitle: 'Herstelcodes opnieuw genereren',
      regenerateHint: 'Alle tot nu toe uitgegeven codes werken niet meer zodra de nieuwe set gegenereerd is.',
      regenerateConfirm: 'Opnieuw genereren',
      regenerateError: 'De herstelcodes konden niet opnieuw worden gegenereerd',
      remove: 'Verwijderen',
      removeTitle: 'De tweede factor verwijderen',
      removeConfirm: 'Verwijderen',
      removeHint: 'Het account gaat terug naar alleen een wachtwoord. Je kunt de tweede factor op elk moment opnieuw instellen.',
      removeRequiredHint:
        'Een beheerder vereist de tweede factor op dit account, dus de server zal de verwijdering weigeren — vraag eerst of de verplichting eraf kan.',
      removeError: 'De tweede factor kon niet worden verwijderd'
    },
    profile: {
      menu: 'Ga naar mijn profiel',
      sessions: 'Actieve sessies',
      sessionsHint: 'Je open sessies op deze node',
      sessionsEmpty: 'Geen actieve sessies',
      sessionCreated: 'Ingelogd op',
      sessionExpires: 'Verloopt',
      revoke: 'Sessie intrekken',
      revokeError: 'De sessie kon niet worden ingetrokken',
      loadError: 'De sessies konden niet worden geladen'
    }
  }
}
